import loadJSON from "./loadJSON";

const publicApi = loadJSON(`${process.env.PUBLIC_URL}/api/api.json`);
const BASE_URL = publicApi.BASE_URL;

// Login
const APP_SECURITY_TOKEN = publicApi.APP_SECURITY_TOKEN;
const SSO_CODE = publicApi.SSO_CODE;
const storedValue = sessionStorage.getItem("appId");
const ENV = publicApi.ENV;
let APP_ID = null;

const SIGNATURE_PROFILE_CONDITION_TYPES = publicApi.SIGNATURE_PROFILE_CONDITION_TYPES;

if (storedValue && storedValue !== '') {
    const valuesArray = storedValue.split(',');
    APP_ID = Object.freeze(valuesArray);  
}

// BFF
const DASHBOARD_BFF_LOGIN = BASE_URL+publicApi.DASHBOARD_BFF_LOGIN;
const DASHBOARD_BFF_API = BASE_URL + publicApi.DASHBOARD_BFF_API;
const DASHBOARD_BFF_SSO_LOGIN = BASE_URL + publicApi.DASHBOARD_BFF_SSO_LOGIN;
const DASHBOARD_BFF_LOGOUT = BASE_URL + publicApi.DASHBOARD_BFF_LOGOUT;
const DASHBOARD_BFF_CREDIT_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_CREDIT_API;
const DASHBOARD_BFF_PAGINATED_TRANSACTION_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_PAGINATED_TRANSACTION_API;
const DASHBOARD_TRANSACTION_IN_FILE_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_TRANSACTION_IN_FILE_DOWNLOAD;
const DASHBOARD_BFF_BULK_CSV_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_BFF_BULK_CSV_DOWNLOAD;
const DASHBOARD_BFF_SCT_CSV_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_BFF_SCT_CSV_DOWNLOAD;
const DASHBOARD_BFF_SCT_BULK_CSV_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_BFF_SCT_BULK_CSV_DOWNLOAD;
const DASHBOARD_BFF_DEBIT_CSV_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_BFF_DEBIT_CSV_DOWNLOAD;

const DASHBOARD_BFF_TRANSACTION_DETAIL_API = BASE_URL+publicApi.API_VERSION_TRANSACTION_DETAIL+"APP_ID"+publicApi.DASHBOARD_BFF_TRANSACTION_DETAIL_API;
const DASHBOARD_BFF_REFOUND_ON_TRANSACTION_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_REFOUND_ON_TRANSACTION_API;
const DASHBOARD_BFF_NEW_PAYMENT_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_NEW_PAYMENT_API;
const DASHBOARD_BFF_REFUND = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_REFUND;
const DASHBOARD_BFF_TRANSACTION_LOG_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_TRANSACTION_LOG_API; 
const DASHBOARD_BFF_ADD_USER_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_ADD_USER_API;
const DASHBOARD_BFF_DELETE_USER_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_DELETE_USER_API;
const DASHBOARD_BFF_RESET_USER_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_RESET_USER_API;
const DASHBOARD_BFF_CHANGE_PASSWORD_API = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_CHANGE_PASSWORD_API;
const DASHBOARD_BFF_DOWNLOAD_CSV = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_DOWNLOAD_CSV;
const DASHBOARD_BFF_GET_USERS = BASE_URL+"APP_ID"+publicApi.DASHBOARD_BFF_GET_USERS;

//SEPA
const DASHBOARD_SEPA_SDD_SUMMARY = BASE_URL + publicApi.DASHBOARD_SEPA_SDD_SUMMARY;
const DASHBOARD_SEPA_SCT_SUMMARY = BASE_URL + publicApi.DASHBOARD_SEPA_SCT_SUMMARY;
const DASHBOARD_SEPA_SDD_OVERVIEW = BASE_URL + publicApi.DASHBOARD_SEPA_SDD_OVERVIEW;
const DASHBOARD_SEPA_SCT_OVERVIEW = BASE_URL + publicApi.DASHBOARD_SEPA_SCT_OVERVIEW;
const DASHBOARD_TRANSACTION_OUT_FILE_SDD = BASE_URL + publicApi.DASHBOARD_TRANSACTION_OUT_FILE_SDD;
const DASHBOARD_BFF_PAGINATED_BULK_SDD_API = BASE_URL + publicApi.DASHBOARD_BFF_PAGINATED_BULK_SDD_API;
const DASHBOARD_BFF_PAGINATED_SDD_DEBIT_API = BASE_URL + publicApi.DASHBOARD_BFF_PAGINATED_SDD_DEBIT_API;
const DASHBOARD_BFF_SDD_DEBIT_DETAIL_API = BASE_URL + publicApi.DASHBOARD_BFF_SDD_DEBIT_DETAIL_API;
const DASHBOARD_BFF_SDD_BULK_DETAIL_API = BASE_URL + publicApi.DASHBOARD_BFF_SDD_BULK_DETAIL_API;
const DASHBOARD_BFF_PAGINATED_SCT_CREDIT_API = BASE_URL + publicApi.DASHBOARD_BFF_PAGINATED_SCT_CREDIT_API;
const DASHBOARD_BFF_SCT_CREDIT_DETAIL_API = BASE_URL+publicApi.DASHBOARD_BFF_SCT_CREDIT_DETAIL_API;
const DASHBOARD_SDD_FILE_LIST = BASE_URL+publicApi.DASHBOARD_SDD_FILE_LIST;
const DASHBOARD_DOWNLOAD_BULK_SCT = BASE_URL+publicApi.DASHBOARD_DOWNLOAD_BULK_SCT;
const DASHBOARD_DOWNLOAD_SCT_FILE = BASE_URL+publicApi.DASHBOARD_DOWNLOAD_SCT_FILE;
const DASHBOARD_SCT_FILE_LIST = BASE_URL+publicApi.DASHBOARD_SCT_FILE_LIST;
const DASHBOARD_BFF_PAGINATED_SCT_CREDIT_BULK_API = BASE_URL+publicApi.DASHBOARD_BFF_PAGINATED_SCT_CREDIT_BULK_API;
const DASHBOARD_SCT_BULK_DETAIL = BASE_URL+publicApi.DASHBOARD_SCT_BULK_DETAIL;

//PRODUCTS
const DASHBOARD_BFF_GET_PRODUCTS = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_PRODUCTS;
const DASHBOARD_BFF_GET_PRODUCTS_RELATIVE = "/APP_ID"+publicApi.DASHBOARD_BFF_PRODUCTS;

//SIGNATURE SCT
const DASHBOARD_BFF_SIGN_BULK_SCT = BASE_URL+publicApi.DASHBOARD_BFF_SIGN_BULK_SCT;
const DASHBOARD_BFF_APPROVE_SCT = BASE_URL+publicApi.DASHBOARD_BFF_APPROVE_SCT;
const DASHBOARD_BFF_REJECT_SCT = BASE_URL+publicApi.DASHBOARD_BFF_REJECT_SCT;
const DASHBOARD_BFF_SIGN_SCT = BASE_URL+publicApi.DASHBOARD_BFF_SIGN_SCT;
const DASHBOARD_BFF_SIGNATURE_USER_API = BASE_URL+publicApi.DASHBOARD_BFF_SIGNATURE_USER_API;
const DASHBOARD_BFF_SIGNATURE_PROFILE_API = BASE_URL+publicApi.DASHBOARD_BFF_SIGNATURE_PROFILE_API;
const DASHBOARD_BFF_REQUEST_OTP_SCT = BASE_URL+publicApi.DASHBOARD_BFF_REQUEST_OTP_SCT;

//CONFIG
const APP_PARAM_VIEWERS = publicApi.APP_PARAM_VIEWERS;
const APP_TECHNICAL_PARAMETERS = publicApi.APP_TECHNICAL_PARAMETERS;
const APP_PARAM_LABELS = publicApi.APP_PARAM_LABELS;

export {
    APP_ID, DASHBOARD_BFF_API,BASE_URL,DASHBOARD_BFF_CREDIT_API,ENV,DASHBOARD_BFF_LOGIN,DASHBOARD_BFF_TRANSACTION_DETAIL_API,DASHBOARD_BFF_PAGINATED_SCT_CREDIT_API,
    DASHBOARD_BFF_PAGINATED_TRANSACTION_API, DASHBOARD_TRANSACTION_IN_FILE_DOWNLOAD, DASHBOARD_TRANSACTION_OUT_FILE_SDD, DASHBOARD_BFF_PAGINATED_BULK_SDD_API,
    DASHBOARD_BFF_NEW_PAYMENT_API,DASHBOARD_BFF_TRANSACTION_LOG_API,DASHBOARD_BFF_ADD_USER_API,DASHBOARD_BFF_DELETE_USER_API,DASHBOARD_BFF_REFOUND_ON_TRANSACTION_API,
    DASHBOARD_BFF_RESET_USER_API,DASHBOARD_BFF_CHANGE_PASSWORD_API,DASHBOARD_BFF_REFUND,DASHBOARD_BFF_DOWNLOAD_CSV,DASHBOARD_BFF_GET_USERS, DASHBOARD_BFF_SDD_DEBIT_DETAIL_API,
    APP_SECURITY_TOKEN,DASHBOARD_SDD_FILE_LIST, SSO_CODE,
    DASHBOARD_BFF_LOGOUT,DASHBOARD_BFF_SSO_LOGIN,DASHBOARD_BFF_SCT_CSV_DOWNLOAD, DASHBOARD_BFF_BULK_CSV_DOWNLOAD, DASHBOARD_BFF_SCT_BULK_CSV_DOWNLOAD, DASHBOARD_BFF_DEBIT_CSV_DOWNLOAD,
    DASHBOARD_BFF_PAGINATED_SDD_DEBIT_API,DASHBOARD_BFF_SDD_BULK_DETAIL_API,DASHBOARD_BFF_SCT_CREDIT_DETAIL_API,DASHBOARD_DOWNLOAD_BULK_SCT,DASHBOARD_DOWNLOAD_SCT_FILE,
    DASHBOARD_SCT_FILE_LIST,DASHBOARD_BFF_PAGINATED_SCT_CREDIT_BULK_API,DASHBOARD_SCT_BULK_DETAIL,DASHBOARD_SEPA_SDD_SUMMARY,DASHBOARD_SEPA_SCT_SUMMARY, DASHBOARD_SEPA_SDD_OVERVIEW,
    DASHBOARD_SEPA_SCT_OVERVIEW, DASHBOARD_BFF_GET_PRODUCTS,DASHBOARD_BFF_SIGN_BULK_SCT,DASHBOARD_BFF_APPROVE_SCT,DASHBOARD_BFF_REJECT_SCT,DASHBOARD_BFF_SIGN_SCT,
    DASHBOARD_BFF_SIGNATURE_USER_API,DASHBOARD_BFF_SIGNATURE_PROFILE_API,
    SIGNATURE_PROFILE_CONDITION_TYPES, DASHBOARD_BFF_REQUEST_OTP_SCT, APP_PARAM_VIEWERS, APP_TECHNICAL_PARAMETERS, APP_PARAM_LABELS,
    DASHBOARD_BFF_GET_PRODUCTS_RELATIVE
};